module.exports = __webpack_public_path__ + "img/tiktok.a1b6d1c.png";